const _AccountEditCommonHandler = (function () {
    const init = () => {
        const passwordInput = $('[name="password"]');
        const passwordConfirmationInput = $('[name="password_confirmation"]');
        const currentPasswordInput = $('[name="current_password"]');
        $(passwordInput).on('input', async function () {
            const passwordValue = passwordInput.val();
            const isDisabled = (typeof passwordValue == 'string' ? passwordValue.length : 0) === 0;
            passwordConfirmationInput.prop('disabled', isDisabled);
            currentPasswordInput.prop('disabled', isDisabled);
        });
    };
    return {
        // Public functions
        init,
    };
})();
window.AccountEditCommonHandler = _AccountEditCommonHandler;
export {};
